import React, { useState, useEffect } from "react";
import EmGptChatBox from "../ProductDashboard/Emgpt/EmgptChatBox";
import DocAssistantFilterBar from "../Common/DocAssistantFilterBar";
import report_reader_logo from "../../../assets/report_reader.png";
import report_reader_logo_1 from "../../../assets/report_reader_1.png";

import {
  fetchDocumentIdsWithDataSource,
  retrivePdfUrl,
  retriveRelevantImages,
  filterDocuments,
  fetchChatSuggestions, // ✅ imported from utilities
} from "../../utilities/DocAssistantUtilities";
import RelevantSection from "./RelevantSection";
import { formatLabel } from "../../utilities/CommonUtilities";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const chatSuggestionsList = {
  Company: [
    "Summarize the key highlights of the document.",
    "What are the main goals and achievements mentioned?",
    "List the challenges discussed in the document.",
  ],
  IMF: [
    "Summarize the Document based on the selected filters.",
    "Summarize the GDP Growth for the selected year and country.",
    "What are the challenges and progress mentioned in the Document?",
  ],
};

function DocAssistant() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const document_type = params.get("document_type");

  const [pageNumbers, setPageNumbers] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [inUseDocumentIds, setInUseDocumentIds] = useState([]);
  const [documentIds, setDocumentIds] = useState([]);
  const [title, setTitle] = useState("");
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);
  const [chatSuggestions, setChatSuggestion] = useState(
    chatSuggestionsList[document_type]
  );
  const [message, setMessage] = useState(
    "Please select filters to view documents"
  );

  const [selectedFilters, setSelectedFilters] = useState({
    country: null,
    documentType: null,
    year: null,
    data_source: null,
    category_theme: null,
  });

  useEffect(() => {
    if (
      selectedFilters.country &&
      selectedFilters.year &&
      selectedDocumentType &&
      documentIds.length > 0
    ) {
      const filteredDocs = filterDocuments(documentIds, selectedFilters);

      setInUseDocumentIds(filteredDocs);
      setMessage(
        filteredDocs.length
          ? ""
          : "No documents found for the selected filters."
      );
    } else {
      setInUseDocumentIds([]);
      setMessage("Please select all required filters to view documents.");
    }
  }, [selectedFilters, documentIds, selectedDocumentType]);

  useEffect(() => {
    if (selectedDocumentType) {
      fetchDocumentIdsWithDataSource(selectedDocumentType, setDocumentIds);
    }
  }, [selectedDocumentType]);

  useEffect(() => {
    if (document_type) {
      setSelectedFilters({
        country: null,
        documentType: null,
        year: null,
        data_source: null,
        category_theme: null,
      });
      setChatSuggestion(chatSuggestionsList[document_type]);
      setSelectedDocumentType({ value: document_type, label: document_type });
      setInUseDocumentIds([]);
    }
  }, [document_type]);

  useEffect(() => {
    retriveRelevantImages(pageNumbers, inUseDocumentIds, setImageUrls);
  }, [pageNumbers]);

  useEffect(() => {
    if (inUseDocumentIds.length === 1) {
      const fileName = inUseDocumentIds[0]?.document_name || "";
      const title = formatLabel(fileName.split(".")[0]);
      setTitle(title);
      retrivePdfUrl(inUseDocumentIds, setPdfUrl);
      if (document_type === "IMF") {
        fetchChatSuggestions(
          inUseDocumentIds,
          setChatSuggestion,
          "report_reader_IMF",
          [selectedFilters.country]
        );
      } else if (document_type === "Company") {


        const companyName = selectedFilters?.selected_company || "";
        const dataSource = selectedFilters?.data_source || [""];
        fetchChatSuggestions(
          inUseDocumentIds,
          setChatSuggestion,
          "report_reader_COMPANY",
          [companyName, dataSource[0] || ""]
        );
      }
    }
  }, [inUseDocumentIds]);

  const getHeight = () => {
    const div = document.getElementById("component_section");
    return div?.clientHeight - 40 || 500;
  };

  return (
    <>
      <Helmet>
        <title>Report Reader | EMAlpha</title>
      </Helmet>
      <div className="d-flex" style={{ height: "70px", width: "100%" }}>
        <DocAssistantFilterBar
          setSelectedFilters={setSelectedFilters}
          selectedDocumentType={selectedDocumentType}
          setSelectedDocumentType={setSelectedDocumentType}
          documentIds={documentIds}
          inUseDocumentIds={inUseDocumentIds}
          document_type={document_type}
        />
      </div>
      <div
        className="d-flex flex-column bg-white rounded-4"
        style={{ height: "92%" }}
      >
        {inUseDocumentIds.length !== 1 ? (
          <>
            {document_type === "IMF" ? (
              <>
                <div className="d-flex flex-row align-items-center m-2 shadow bg-white rounded-4 w-100 h-100">
                  <div className="w-40 h-100 d-flex justify-content-center  flex-column p-4">
                    <h1
                      className="mb-3 h1 fw-bold"
                      style={{ fontSize: "48px" }}
                    >
                      IMF Reports
                      <br />
                      Reader
                    </h1>
                    <p className="mb-2 " style={{ fontSize: "24px" }}>
                      Analyze IMF Reports with ease.
                    </p>
                    <p className="mb-0" style={{ fontSize: "24px" }}>
                      Select the desired country and year to get started.
                    </p>
                  </div>
                  <div className="w-50 h-100 d-flex align-items-center  justify-content-center p-4">
                    <img
                      src={report_reader_logo_1}
                      alt="AI Report Reader"
                      className="img-fluid"
                      style={{ maxHeight: "100%", objectFit: "contain" }}
                    />{" "}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="d-flex flex-row align-items-center m-2 shadow bg-white rounded-4 w-100 h-100">
                  <div className="w-50 h-100 d-flex justify-content-center align-items-center p-4">
                    <img
                      src={report_reader_logo}
                      alt="AI Report Reader"
                      className="img-fluid"
                      style={{ maxHeight: "100%", objectFit: "contain" }}
                    />
                  </div>
                  <div className="w-50 h-100 d-flex flex-column justify-content-center p-4">
                    <h1 className="mb-3 h1" style={{ fontSize: "40px" }}>
                      AI-Powered Report Reader
                      <br />
                      for Global Company Disclosures
                    </h1>
                    <p className="mb-2 " style={{ fontSize: "18px" }}>
                      Get fast insights from Annual Reports, CSR, and ESG
                      documents using multilingual AI. EMAlpha reads and
                      summarizes complex documents so you don’t have to.
                    </p>
                    <p className="mb-0" style={{ fontSize: "18px" }}>
                      Start by selecting the country, company, year, and report
                      type from the dropdowns above.
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <div className="border-4 rounded-2 ms-2 p-2">
              <h5>{title}</h5>
            </div>
            <div
              className="d-flex flex-grow-1 flex-row bg-white"
              style={{ height: "90%" }}
            >
              <div
                className="p-2 flex-grow-1 bg-white overflow-auto ms-2"
                id="component_section"
                style={{ maxWidth: "50%", height: "98%" }}
              >
                <EmGptChatBox
                  inUseDocumentIds={inUseDocumentIds}
                  setPageNumbers={setPageNumbers}
                  height={getHeight()}
                  getPageNumber={true}
                  chatSuggestions={chatSuggestions}
                  document_type={document_type}
                  selectedFilters={selectedFilters}
                />
              </div>
              <div
                className="p-2 flex-grow-1 bg-white ms-2"
                style={{ maxWidth: "50%", height: "100%", overflow: "hidden" }}
              >
                <RelevantSection
                  imageUrls={imageUrls}
                  pdfUrl={pdfUrl}
                  pageNumber={pageNumbers}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default DocAssistant;
